import { useTranslation } from "react-i18next"
import { useDownload } from "../../../../../../../../hooks/download/useDownload"
import { loogbookServiceFetch } from "../../../../../../../../utils/constants/callService"
import { returnQueryWithPagination } from "../../../../../../../../utils/methods/returnQuery"
import { TableActions } from "../../tableActions"
import { useLogbookContext } from "../../../../context"
import { Hashs } from "../../../activityRegister/utils"
import { formatUserMapFilter } from "../../../../utils"
import { useEffect } from "react"
import { LinearProgressDownload } from "../linearProgressDownload"
import { UserSection } from "../../../../utils/enums/userSection"

export const MyActivityAction = () => {
    const { filter: { filterMyActivity: { filter } }, service: { getDetailInform }, state: { uuid, loading }, setVisibleUsersData } = useLogbookContext()
    const { t } = useTranslation()
    const query = returnQueryWithPagination({ filter: filter.filterString }, formatUserMapFilter);
    const downloadCustome = () => {
        getDetailInform({ query: query, uuidTab: UserSection.MY_ACTIVITY })
    }
    const cleanFilterAll = () => {
        filter.cleanFilter()
        setVisibleUsersData({})
    }
    const {
        download,
        openSnackbar,
        downloadCSV,
        downloadPDF,
        downloadWORD,
        closeOpenSnakbar
    } = useDownload({
        query: query,
        docName: t('loogbook.activity'),
        downloadFuntion: loogbookServiceFetch.downloadLogbook,
    })

    useEffect(() => {
        if (uuid.MY_ACTIVITY) {
            const interval = setInterval(() => {
                getDetailInform({ query, uuidTab: UserSection.MY_ACTIVITY });
            }, 30000);
            return () => clearInterval(interval);
        }
    }, [uuid.MY_ACTIVITY])

    return (<>
        <LinearProgressDownload show={loading.MY_ACTIVITY} text={t('loogbook.generateDetailInform')} />
        <TableActions
            download={{
                csv: downloadCSV,
                pdf: downloadPDF,
                word: downloadWORD,
                disableCSV: download?.excel,
                disablePDF: download?.pdf,
                disableWORD: download?.word
            }}
            count={filter.counter}
            cleanActivityButton={{ onClick: cleanFilterAll }}
            downloadCustome={downloadCustome}
            downloadDisabled={{ 'pdf-detail': loading.MY_ACTIVITY, excel: false, pdf: false, word: false }}
            closeOpenSnakbar={closeOpenSnakbar}
            openSnackbar={openSnackbar}
            addActivityButton={{ onClick: () => { window.location.hash = Hashs.CREATE } }}
        />
    </>)
}